module.exports = "/_next/static/images/parallax-2-ea38ad224c30411575a3214c3800242e.jpg.webp";